import { get } from "helpers/api_helper"
import {
  normalizeAdminListFilters,
  normalizeAdminListOptions,
  removeAdminListSearchFilter,
} from "helpers/adminListQueryPolicy"
import toastr from "toastr"
import { writeOrganizerQuery } from "./listQuery"
import { loadOrganizerClubs } from "./assignedClubs"

export const getOrganizersLocations = async filter => {
  const { location, ...facetFilters } = removeAdminListSearchFilter(filter)
  const filters = new URLSearchParams(facetFilters).toString()
  const response = await get(`/admin/organizers/locations?${filters}`)
  if (!Array.isArray(response?.data)) throw new Error("Invalid organizer locations response")
  return response
}

export const getOrganizers = async (filter, options) => {
  const filters = new URLSearchParams({
    ...normalizeAdminListFilters(filter),
    ...normalizeAdminListOptions(options),
  }).toString()
  const response = await get(`/admin/organizers?${filters}`)
  const data = response?.data
  if (!Array.isArray(data?.results) || !Number.isInteger(data.totalResults) || data.totalResults < 0
    || !Number.isInteger(data.page) || data.page < 1 || !Number.isInteger(data.limit) || data.limit < 1
    || data.results.some(account => !account?.id || account.isOrganizer !== true)) {
    throw new Error("Invalid organizer list response")
  }
  const results = await loadOrganizerClubs(data.results)
  return { ...response, data: { ...data, results, queryKey: writeOrganizerQuery(filter, options) } }
}

// A refused or unanswered read rejects: the profile says why (ProfileLoadError).
export const getOrganizerInfo = id => get(`/accounts/${id}`)

export const getOwnerClub = async id => {
  let response
  try {
    response = await get(`/clubs/owners/${id}`)
  } catch (error) {
    toastr.error(error.response.data?.message)

    response = error.response.data
  }
  return response
}

// export const getOwnerClub = async id => {
//   let response
//   try {
//     response = await get(`/clubs/owners/${id}`)
// A refused or unanswered read rejects: the profile's Tournaments card says so.
export const getTournaments = (id, options) => {
  const query = new URLSearchParams({
    ...normalizeAdminListOptions(options, { page: 1, limit: 10 }),
    sortBy: options?.sortBy || "startDate:desc",
  }).toString()
  return get(`/organizers/${id}/events?${query}`)
}
